import { createFileRoute } from '@tanstack/react-router'

import { PermissionsPage } from '@/components/Internal/System/PermissionsPage'

export const Route = createFileRoute('/internal/system/operations/permissions')(
  {
    component: PermissionsPage,
  },
)
